import httpClient from "../../clients/httpClient";
import { IQuery } from "../../interfaces/meta.interface";
import {
    IReward,
    IRewardRedemptionQuery,
    IRewardRedemptionResponse,
    IRewardResponse,
    IAvailableRewardsQuery,
    IAvailableRewardsResponse,
} from "../../interfaces/reward.interface";
import { IBirchmountProductsResponse } from "../../interfaces/birchmount-product.interface";

export const getRewards = (query: IQuery) => {
    return httpClient.get("/api/v1/rewards", {
        params: {
            page: query?.page,
            per_page: query?.perPage,
            direction: query?.sortDirection,
            sort: query?.orderBy,
            status: query?.status,
            search: query?.search,
        },
    });
};

export const getReward = (id: number) => {
    return httpClient.get<IRewardResponse>(`/api/v1/rewards/${id}`, {
        params: {
            include: "products",
        },
    });
};

export const createReward = (payload: FormData) => {
    return httpClient.post<IReward>(`/api/v1/rewards`, payload);
};

export const editReward = (id: number, payload: FormData) => {
    return httpClient.post<IReward>(`/api/v1/rewards/${id}`, payload, {
        params: {
            include: "products",
        },
    });
};

export const deleteRewardRequest = (id: number) => {
    return httpClient.delete(`/api/v1/rewards/${id}`);
};

export const getCheckoutRewardsRequest = (storeId: string, token: string) => {
    return httpClient.get<IReward[]>(
        `/api/v1/store/${storeId}/rewards/${token}`
    );
};

export const getRewardRedemptions = (
    organizationId: number,
    userId: number,
    query: IRewardRedemptionQuery
) => {
    return httpClient.get<IRewardRedemptionResponse>(
        `/api/v1/organizations/${organizationId}/customer/${userId}/rewards/redemptions`,
        {
            params: {
                page: query?.page,
                per_page: query?.perPage,
                status: query?.status,
            },
        }
    );
};

export const getAvailableRewards = (
    organizationId: number,
    userId: number,
    query: IAvailableRewardsQuery
) => {
    return httpClient.get<IAvailableRewardsResponse>(
        `/api/v1/organizations/${organizationId}/customer/${userId}/rewards/available`,
        {
            params: query,
        }
    );
};

export const syncRewardRequest = (tenantId: string) => {
    return httpClient.post(`/api/v1/organizations/${tenantId}/rewards/sync`);
};

export const getBirchmountProducts = () => {
    return httpClient.get(`/api/v1/birchmount/products`);
};